module.exports = __webpack_public_path__ + "img/standort_schulhaus-zentral.02f9aa0a.png";